import _mimeTypes from "./mime-types.json";
var exports = {};
// sourced from:
// http://www.leanbackplayer.com/test/h5mt.html
// https://github.com/broofa/node-mime/blob/master/types.json
var mimeTypes = _mimeTypes;
var mimeLookup = {};
Object.keys(mimeTypes).forEach(function (key) {
  var extensions = mimeTypes[key];
  extensions.forEach(function (ext) {
    mimeLookup[ext] = key;
  });
});

exports = function lookup(ext) {
  if (!ext) throw new TypeError("must specify extension string");

  if (ext.indexOf(".") === 0) {
    ext = ext.substring(1);
  }

  return mimeLookup[ext.toLowerCase()];
};

export default exports;